import { onBeforeUnmount } from 'vue';

export function guardBrowserClose(isDirty) {
  const handler = event => {
    if (isDirty()) {
      event.preventDefault();
      event.returnValue = '';
    }
  };
  window.addEventListener('beforeunload', handler);
  onBeforeUnmount(() => window.removeEventListener('beforeunload', handler));
}
